let scheduledCalls: (() => void)[] = [];
let appIsReady = false;

export const callAfterAppReady = (cb: () => void) => {
  if (appIsReady) {
    cb();
  } else {
    scheduledCalls.push(cb);
  }
};

export const releaseAfterAppReady = () => {
  scheduledCalls.forEach(cb => cb());
  scheduledCalls = [];
  appIsReady = true;
};
